module.exports = __webpack_public_path__ + "static/media/image04.2e9bf049.png";